import React from 'react';
import Image from 'next/image';

import { getAssessmentsProps } from 'router/seoprops/pages/assessments';
import { NextSeo } from 'next-seo';

import { setSsrTokens } from 'utils/authentication';
import { useQuery } from 'react-query';
import { QueryClient, dehydrate } from 'react-query';
import { GetAllAssessments } from 'services/core';
import { queryClientConfig } from '@core/configs/queryClientConfig';
import Spinner from '@core/components/spinner/Spinner';
import AssessmentCard from 'components/pages/assessments/assessmentcard/AssessmentCard';
import FAQ from 'components/common/faq/FAQ';
import { assessmentsFaq } from 'constants/explore-faq.const';

import AssessmentHeaderImage from 'assets/images/pages/assessment/assessments-header.webp';

import classes from './assessments.module.scss';


const index = () => {
    const seoProps = getAssessmentsProps();
    const { data, isLoading } = useQuery(['assessments'], GetAllAssessments);
    return (
        <>
            <NextSeo {...seoProps} />
            <div className='container '>
                <div className='row d-flex justify-content-center'>
                    <div className='col-xxl-10 col-12'>
                        <div className={classes['wrapper']}>
                            <div className={classes['assessments-header']}>
                                <Image
                                    src={AssessmentHeaderImage}
                                    alt="Assessments header"
                                    className={classes['header-bg']}
                                    fill
                                    priority
                                />
                                <h1>Explore Pharma Skill Assessments</h1>
                                <p>Measure your readiness for a specific pharma role with our free, role-based assessments. After a quick free registration, you’ll receive your overall score, detailed topic-level results, and see where you stand compared to other participants on a normal distribution curve.
                                    <br />
                                    You’ll also get a visual skill tree breakdown and personalized course recommendations to help you close your gaps and move forward with confidence.
                                </p>
                            </div>
                            {(data && !isLoading) && (
                                <div className={classes['assessments-card-wrapper']}>
                                    {data?.data.map((assessment, index) => (
                                        <AssessmentCard key={index} data={assessment} />
                                    ))}
                                </div>
                            )}
                            {isLoading && (
                                <div className={classes['loading']}>
                                    <Spinner />
                                </div>
                            )}
                            <div className='mt-5'>
                                <FAQ data={assessmentsFaq} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export async function getServerSideProps(context) {
    setSsrTokens(context);
    const queryClient = new QueryClient(queryClientConfig);
    const response = await GetAllAssessments();
    await queryClient.prefetchQuery(['assessments'], () => ({ data: response.data }));
    return {
        props: {
            dehydratedState: dehydrate(queryClient)
        }
    };
}

export default index;